import { useState } from 'react';

/** 로컬 날짜 → 'YYYY-MM-DD' (API 파라미터·createdAt 앞 10자리 비교용). toISOString 은 UTC 라 날짜가 하루 밀릴 수 있어 쓰지 않는다 */
export function toIsoDay(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** ui-core DateRangePicker 값과 같은 모양 */
export interface DateRangeState {
  start: Date | null;
  end: Date | null;
}

const EMPTY: DateRangeState = { start: null, end: null };

/**
 * 기간 필터 공용 훅 — DateRangePicker 값 + 조회용 dateFrom/dateTo('YYYY-MM-DD').
 * DateRangePicker 는 첫 클릭(시작일)에도 onChange 를 부르므로, 시작·종료가 모두 정해졌을 때만
 * dateFrom/dateTo 를 내보낸다 — 고르는 도중 조회가 나가거나 목록이 깜빡이지 않게.
 *
 *   const { dateRange, setDateRange, dateFrom, dateTo, reset } = useDateRangeFilter();
 *   <DateRangePicker value={dateRange} onChange={setDateRange} />
 */
export function useDateRangeFilter(initial: DateRangeState = EMPTY) {
  const [dateRange, setDateRange] = useState<DateRangeState>(initial);
  const complete = !!dateRange.start && !!dateRange.end;
  return {
    dateRange,
    setDateRange,
    dateFrom: complete ? toIsoDay(dateRange.start!) : '',
    dateTo: complete ? toIsoDay(dateRange.end!) : '',
    reset: () => setDateRange(EMPTY),
  };
}
